import RazorpayCommon from './razorpay-common';

export default RazorpayCommon;
